import { random, forEach, replace } from 'lodash';

export function parseMessageContent(messageHtml) {
  let message = messageHtml;
  const links = {};
  // regexp to match valid url values
  const urlPattern =
    // eslint-disable-next-line max-len
    '((([A-Za-z]{3,9}:(?://)?)(?:[-;:&=+$,\\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\\w]+@)[A-Za-z0-9.-]+)(:[0-9]+)?((?:/[+~%/.\\w-_]*)?\\??(?:[-+=&;%@.\\w_]*)#?(?:[.!/\\\\w]*))?)';
  const urlRegexp = new RegExp(urlPattern, 'gm');
  // regexp to match valid url values with href attribute
  const linkRegexp = /<\s*a[^>]*>(.*?)<\s*\/\s*a>/g;

  // sanitize link tags to avoid double replace
  message = message.replace(linkRegexp, (match) => {
    const linkKey = `links_${random(999)}`;

    links[linkKey] = match;

    return `{{${linkKey}}}`;
  });

  message = message.replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // wrap urls on clickable links
  message = message.replace(urlRegexp, (match) => {
    const result = match.replace(/[.]{1}$/, '');
    const url = result.indexOf('.') > 0 && !/^(https?)/.test(result) ? `http://${result}` : result;

    return `<a href="${url}">${result}</a>${match[match.length - 1] === '.' ? '.' : ''}`;
  });

  // add links url again
  forEach(links, (value, key) => {
    message = message.replace(`{{${key}}}`, value);
  });

  return message
    .replace(/(a href=)/g, 'a target="_blank" href=')
    .replace(/$/g, '<br />')
    .replace(/&lt;br&gt;/g, '<br />')
    .replace(/&lt;br \/&gt;/g, '<br />');
}

export function capitalizeFirstLetter(s) {
  if (!s) {
    return '';
  }
  return (s.charAt(0).toUpperCase() + s.slice(1)).replace(/-|_/, ' ');
}

export function lowercaseFirstLetter(s) {
  if (!s) {
    return '';
  }
  return (s.charAt(0).toLowerCase() + s.slice(1)).replace(/-|_/, ' ');
}

export function updateText(text, replacements) {
  let res = text;
  forEach(replacements, ({ prev, next }) => {
    res = replace(res, prev, next);
  });
  return res;
}

export function isHTML(str) {
  // https://stackoverflow.com/a/15458968
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}

 export function formatParticipantName(name) {
   if (!name) {
     return '';
   }

  return replace(name.split(':')[0], /\s[\d]+$/gi, '');
 }
